'use strict';

/**
 * will generate a form and submit it
 * data-sw-post-to-url='<selector for all the fields to be included in the form>'
 * data-sw-post-to-url-action='<pass the action url>'
 * data-sw-post-to-url-method='<pass the method type, by default it will be set to post>'
 * data-sw-post-to-url-target='<pass the target for this form, for example _blank>'
 */

var $ = require('js/sw-jquery/sw-jquery');
var swUtils = require('js/lib/sw-utils');

var ATTRS = {
  ROOT: 'data-sw-post-to-url',
  action: 'data-sw-post-to-url-action',
  method: 'data-sw-post-to-url-method',
  target: 'data-sw-post-to-url-target'
};

var DEFAULT_METHOD_TYPE = 'post';

$(function () {
  var $body = $('body');
  var mainSelector = swUtils.makeAttributeValueSelector(ATTRS.ROOT);
  $body.on('click', mainSelector, function eventHandler() {
    var $el = $(this);
    var eventFields = $el.swDataAttr(ATTRS.ROOT);
    var eventAction = $el.swDataAttr(ATTRS.action);
    var eventMethod = $el.swDataAttr(ATTRS.method) || DEFAULT_METHOD_TYPE;
    var eventTarget = $el.swDataAttr(ATTRS.target);
    var form = document.createElement('form');
    form.setAttribute('method', eventMethod);
    form.setAttribute('action', eventAction);
    form.setAttribute('target', eventTarget);

    if (eventFields) {
      var fields = $(eventFields);
      $.each(fields, function () {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', this.name);
        hiddenField.setAttribute('value', this.value);
        form.appendChild(hiddenField);
      });
    }
    document.body.appendChild(form);
    form.submit();
  });
});
